import script from "./DeleteAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteAccount.vue?vue&type=script&setup=true&lang=js"

import "./DeleteAccount.vue?vue&type=style&index=0&id=4a18a54d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a18a54d"]])

export default __exports__